import { render } from "./IconElectraTorque.vue?vue&type=template&id=fe6eed28"
import script from "./IconElectraTorque.vue?vue&type=script&lang=js"
export * from "./IconElectraTorque.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__